enum RuleEnum {
  Registration = 'register',
  Reservation = 'booking'
}

export default RuleEnum;
